import React, { FC } from "react";
import RcDropdown, { DropdownProps } from "rc-dropdown/lib/Dropdown";
import cn from "classnames";
import "rc-dropdown/assets/index.css";
import { getPopupContainer } from "../../shared/getPopupContainer";
import stl from "./index.module.scss";

const Dropdown: FC<DropdownProps> = ({ ...props }) => {
  return (
    <RcDropdown
      getPopupContainer={getPopupContainer}
      {...props}
      overlayClassName={cn(stl.block, props.overlayClassName)}
    />
  );
};

export default Dropdown;
